import React, { useEffect, useState } from 'react';
import { API_URL, fetchOpenEvents } from '../api';
import { useI18n } from '../i18n/LanguageContext';

/** Always announces the next upcoming pilgrimage (the first one still open for booking). */
export default function AnnouncementBar() {
  const { t, formatLongDate } = useI18n();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    if (!API_URL) return undefined;
    let cancelled = false;
    fetchOpenEvents()
      .then((events) => {
        if (cancelled || !events?.length) return;
        const sorted = [...events].sort((a, b) => a.eventDate.localeCompare(b.eventDate));
        setEvent(sorted.find((e) => e.bookingOpen !== false) || sorted[0]);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleReserve = () => {
    // Open the same pilgrimage the bar announces.
    window.dispatchEvent(new CustomEvent('izm:open-reservation', { detail: { eventId: event?.id } }));
  };

  // Monthly pilgrimages are named "… — November 2026"; the date already says the month.
  const name = event ? event.name.split(' — ')[0] : null;
  const open = event ? event.bookingOpen !== false : true;

  return (
    <div className="announcement-bar">
      <span className="announcement-text">
        {event
          ? t(open ? 'banner.open' : 'banner.closed', { name, date: formatLongDate(event.eventDate) })
          : t('banner.fallback')}
      </span>
      {open ? (
        <button type="button" className="announcement-cta" onClick={handleReserve}>
          {t('banner.reserve')}
        </button>
      ) : (
        <span className="announcement-text announcement-closed">{t('banner.booking_closed')}</span>
      )}
    </div>
  );
}
